import React from 'react'
import axios from 'axios'
import { server } from '../index'
import { useState, useEffect } from 'react'
import Loader from './Loader'
import ErrorComponent from './ErrorComponent'
import { Heading, VStack, Text, Image, HStack, Container } from '@chakra-ui/react';
const Exchanges = () => {
  const [exchanges, setExchanges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchExchanges = async () => {
      try {
        const { data } = await axios.get(`${server}/exchanges`);
        console.log(data);
        setExchanges(data);
        setLoading(false);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    };
    fetchExchanges();
  }, []);
  if (error) return <ErrorComponent message={"Error While Fetching Coins"} />;


  return (

    <Container maxW={"container.xl"}>
      {
        loading ? (
          <Loader />
        ) : (
          <>
            <HStack wrap={"wrap"} justifyContent={"space-evenly"}>
              {
                exchanges.map((i) => (
                  <ExchangesCard
                    key={i.id}
                    name={i.name}
                    rank={i.trust_score_rank}
                    img={i.image}
                    url={i.url}
                  />
                ))
              }
            </HStack>
          </>
        )
      }


    </Container>

  );
};
const ExchangesCard = ({ name, img, rank, url }) => (
  <a href={url} target={"blank"}>
    <VStack
      w={"52"}
      shadow={"lg"}
      p={"8"}
      borderRadius={"lg"}
      transition={"all 0.3s"}
      m={"4"}
      css={{
        "&:hover": {
          transform: "scale(1.1)",
        },
      }}>
      <Image
        src={img}
        w={"10"}
        h={"10"}
        objectfit={"contain"}
        alt={"Exchange"} />
      <Heading size={"md"} noOfLines={1}>
        {rank}
      </Heading>
      <Text noOfLines={1}>{name}</Text>
    </VStack>
  </a>
);


export default Exchanges;